<template>
  <div class="modal-container">
    <div class="add-box clearfix">
      <div class="detail-tit-211130 clearfix">
        <h2>关联订单</h2>
        <span v-if="isHavePermission('global:viewCreateTime')">物流编号：{{tableData[0].logisticsNum}} | 创建操作人：{{tableData[0].createUser}} | 创建日期：{{tableData[0].createTime | timeFormatDate}}</span>
        <span v-else>物流编号：{{tableData[0].logisticsNum}} | 客户经理：{{tableData[0].createUser}}</span>
      </div>
      <vxe-table
          border
          show-overflow
          ref="xTable1"
          class="table-style"
          max-height="400"
          align="center"
          :auto-resize="true"
          :data="tableData"
          :edit-config="{trigger: 'click', mode: 'cell'}"
      >
        <vxe-table-column field="chainNum" title="主订单编号">
          <template slot-scope="{ row }">
            <span
                @click="showChainDetail(row)"
                style="color: #2D8CF0;cursor:pointer"
            >{{ row.chainNum }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerOrdersNum" title="子订单编号">
          <template slot-scope="{ row }">
            <a @click="showSellerDetail(row)">{{ row.sellerOrdersNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="buyerName" title="托运人名称"></vxe-table-column>
        <vxe-table-column field="compName" title="平台企业"></vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人名称"></vxe-table-column>
        <vxe-table-column field="sellerNameLv2" title="实际承运人名称"></vxe-table-column>
      </vxe-table>
      <div class="detail-tit-211130 clearfix">
        <h2>物流信息</h2>
      </div>
      <vxe-table
          border
          show-overflow
          ref="xTable2"
          class="table-style"
          max-height="400"
          align="center"
          :auto-resize="true"
          :data="goodsData"
          :edit-config="{trigger: 'click', mode: 'cell'}"
      >
        <vxe-table-column field="logisticsCode" title="物流单号" width="130"></vxe-table-column>
        <vxe-table-column field="isTop" title="状态" width="120">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.isTop | logisticsIsTopStatusMap}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsType" title="货物类型" width="140"></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="90"></vxe-table-column>
        <vxe-table-column field="goodsRule" title="规格" width="70"></vxe-table-column>
        <vxe-table-column field="counts" title="装货数量" width="80"></vxe-table-column>
        <vxe-table-column field="realCount" title="实际数量" width="80"></vxe-table-column>
        <vxe-table-column field="deviate" title="盈亏数量" width="80"></vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位" width="70"></vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="120">
          <template slot-scope="{ row }">
            <span v-if="row.trackUrl || row.logisticsType === 2" @click="getMap(row)"
                  style="color: #2D8CF0;cursor:pointer">{{ row.carShipNum }}</span>
            <span v-if="!row.trackUrl && row.logisticsType !== 2 ">{{ row.carShipNum }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="voyage" title="航次号" width="80"></vxe-table-column>
        <!-- <vxe-table-column field="deliveryPlace" title="交货地点" width="70"></vxe-table-column> -->
        <vxe-table-column field="beginPlace" title="起运地" width="200"></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间" width="150">
          <template slot-scope="{ row }">
            <span style="color: #a7adad" v-if="row.logisticsType === 2">{{ row.beginTime | timeFormatDate}}</span>
             <span style="color: #a7adad" v-else>{{ row.beginTime | timeFormat}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地" width="200"></vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="150">
          <template slot-scope="{ row }">
            <span style="color: #a7adad" v-if="row.logisticsType === 2">{{ row.endTime | timeFormatDate}}</span>
            <span style="color: #a7adad" v-else>{{ row.endTime | timeFormat}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="note" title="备注" width="80"></vxe-table-column>
      </vxe-table>
      <vxe-table
          border
          show-overflow
          :auto-resize="true"
          class="table-upload-style"
          max-height="200"
          :data="uploadData"
          :edit-config="{trigger: 'click', mode: 'cell', icon: 'fa fa-pencil'}"
      >
        <vxe-table-column field="url" title="附件">
          <template v-slot="{row}">
            <upload-list
                :isEdit="false"
                :row="row"
                :initFileList="imageData"
                :view="'arrange'"
            ></upload-list>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button v-if="editVisible && isHavePermission('logistics:updateLogistics')" type="primary" @click="goUpdate">编 辑
      </Button>
    </div>
    <div v-show="trackFlag" class="trackBoxModal">
      <div style="display: flex;justify-content: space-between;">
        <div
            style="margin-left: 10px;font-size: 14px;font-weight: bold;line-height: 30px;"
        >{{isCar ? '车辆轨迹': '船舶轨迹'}}
        </div>
        <div
            @click="trackFlag = false"
            style="margin-right: 5px;cursor: pointer;line-height: 30px;height: 30px;background: #409EFF;color: #fff;border-radius:5px;width:60px;font-size: 12px;font-size: 12px;text-align: center;"
        >关闭
        </div>
      </div>
      <iframe
          ref="mapFrame"
          style="width:100%;height:95vh;overflow: hidden;"
          frameborder="0"
          name="showHere"
          scrolling="auto"
          :src="url"
      ></iframe>
    </div>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import UploadList from '@/components/common/UploadList'
  import getAuthOrization from "@/mixin/getAuthOrization";
  import moment from "moment";

  export default {
    components: {UploadList},
    props: {
      editVisible: {
        type: Boolean,
        default: true,
      },
    },
    mixins: [getAuthOrization],
    data() {
      return {
        imageData: [],
        trackFlag: false,
        url: "",
        isCar: true,
        tableData: [
          {
            logisticsNum: "",
          },
        ],
        goodsData: [{}],
        uploadData: [
          {
            url: null,
          },
        ],
        logisticsId: "",
      };
    },
    methods: {
      goUpdate() {
        this.$emit("goUpdate", this.logisticsId);
      },
      showChainDetail(row) {
        if (!this.isHavePermission('chain:detail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.$router.push(`/order/detail/${row.chainId}`);
        this.$emit("close");
      },
      showSellerDetail(row) {
        if (row.ordersSellerLv2Id) {
          if (!this.isHavePermission('sellerLv2:detail')){
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return ;
          }
          this.$router.push(`/order/secseller/detail/${row.ordersSellerLv2Id}`);
        } else {
          if (!this.isHavePermission('seller:detail')){
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return ;
          }
          this.$router.push(`/order/seller/detail/${row.ordersSellerId}`);
        }
        this.$emit("close");
      },
      getMap(row) {
        if (row.logisticsType === 1) {
          this.isCar = true;
          this.seeCarMap(row);
        } else {
          this.isCar = false;

          this.seeShipMap(row);
        }
      },
      seeCarMap(row) {
        let that = this;
        this.trackFlag = true;
        this.url = '/carShip/fwCarFrame';
        this.$nextTick(function () {
          setTimeout(function () {
            let mapFrame = that.$refs.mapFrame;
            let iframeWin = mapFrame.contentWindow;
            iframeWin.postMessage(JSON.stringify({carInfo: row, logistics: true, top: true}), '*');
          }, 5000);
        });
      },
      seeShipMap(row) {
        let mmsi = row.mmsi ? row.mmsi : row.carShipNum;
        if (mmsi == null || mmsi === '') {
          //暂无数据
          this.$Message.error('暂无数据');
          return
        }
        let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
        let deliveryDates = moment(row.endTime).format("YYYY-MM-DD")
        let obj = {
          startTime: beginTime + " 00:00:00",
          endTime: deliveryDates + " 00:00:00",
          mmsi: mmsi
        }
        this.trackFlag = true;
        let that = this;
        if (this.url === '/carShip/fwShipFrame') {
          let mapFrame = that.$refs.mapFrame;
          let iframeWin = mapFrame.contentWindow
          iframeWin.postMessage(JSON.stringify(obj), '*')
        } else {
          this.url = '/carShip/fwShipFrame';
          this.$nextTick(function () {
            setTimeout(function () {
              let mapFrame = that.$refs.mapFrame;
              let iframeWin = mapFrame.contentWindow
              iframeWin.postMessage(JSON.stringify(obj), '*')
            }, 5000);
          });
        }
      },
      // 船舶日期往前推N天
      dateAddDays(dataStr, dayCount) {
        let isdate = new Date(dataStr.replace(/-/g, "/"));
        isdate = new Date((isdate / 1000 - 86400 * dayCount) * 1000); //日期-N天
        let strMonth = isdate.getMonth() + 1;
        let strDate = isdate.getDate();
        let strYear = isdate.getFullYear();
        if (strMonth >= 1 && strMonth <= 9) {
          strMonth = "0" + strMonth;
        }
        if (strDate >= 1 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return strYear + "-" + strMonth + "-" + strDate;
      },
      async queryLogisticsDetail(id) {
        this.logisticsId = id;
        let res = await $api.logistics.request("queryLogisticsDetail", {
          id: id,
        });
        if (res.status === 1) {
          let data = res.data;
          if (
            data.ordersSellerLv2Num === null ||
            data.ordersSellerLv2Num === ""
          ) {
            if (data.ordersSellerNum === null || data.ordersSellerNum === "") {
              data.sellerOrdersNum = data.ordersBuyerNum;
            } else {
              data.sellerOrdersNum = data.ordersSellerNum;
            }
          } else {
            data.sellerOrdersNum = data.ordersSellerLv2Num;
          }
          if (data.fileList && data.fileList.length > 0) {
            data.fileList.map((i) => {
              this.imageData.push(i);
            });
          }
          this.tableData = [
            {
              chainNum: data.chainNum,
              buyerName: data.buyerName,
              sellerName: data.sellerName,
              sellerNameLv2: data.sellerNameLv2,
              logisticsNum: data.logisticsNum,
              createUser: data.createUser,
              createTime: this.$utils.toDateString(data.createTime, "yyyy-MM-dd"),
              sellerOrdersNum: data.sellerOrdersNum,
              ordersSellerId: data.ordersSellerId,
              ordersSellerLv2Id: data.ordersSellerLv2Id,
              chainId: data.chainId,
            },
          ];
          this.tableData[0].compName = data.compName;
          this.goodsData = [
            {
              logisticsCode: data.logisticsCode,
              logisticsType: data.logisticsType,
              trackUrl:data.trackUrl,
              goodsName: data.goodsName,
              goodsType: data.goodsType,
              goodsRule: data.goodsRule,
              counts: data.counts,
              deviate: data.deviate,
              realCount: data.realCount,
              goodsUnit: data.goodsUnit,
              carShipNum: data.carShipNum,
              voyage: data.voyage,
              deliveryPlace: data.deliveryPlace,
              beginPlace: data.beginPlace,
              beginTime: data.beginTime,
              endPlace: data.endPlace,
              endTime: data.endTime,
              note: data.note,
              fileList: data.fileList,
              isTop: data.isTop
            },
          ];
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      close() {
        this.imageData = [];
        this.tableData = [
          {
            logisticsNum: "",
          },
        ];
        this.goodsData = [{}];
        this.uploadData = [
          {
            url: null,
          },
        ];
        this.logisticsId = "";
      },
    },
  };
</script>

<style scoped>
  .modal-container {
    position: relative;
    height: 100%;
  }

  .modal-footer {
    padding: 10px 0 0 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  /* .detail {
    display: flex;
    align-items: center;
  } */

  /* h2 {
    color: #17233d;
    font-size: 18px;
  } */

  /* .detail span {
    margin-left: auto;
    font-size: 14px;
    color: #808695;
  } */

  .show-pic {
    position: fixed;
    z-index: 99999;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .trackBoxModal {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    background: #fff;
  }
</style>
